import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { initGtm, sendUserInfo } from './gtm'

import VueDaumPostcode from 'vue-daum-postcode'
import { setupDeepLink } from '@/utils/deeplink'

import "@/assets/css/default.css"
import "@/assets/css/quill.snow.css"
import "@/assets/css/common.css"
import "@vueform/toggle/themes/default.css"
import "@/assets/css/style.css"

// GTM 클라이언트 정보는 컨테이너가 첫 태그를 쏘기 전에 올려야 한다.
initGtm()

// GA 로그인 사용자 식별값(gtm.js sendUserInfo).
// 앱 시작 시 보관해 둔 해시로 먼저 올린다 — 문자 딥링크처럼 메인을 거치지 않는 진입도 첫 페이지뷰부터 실린다.
// 이후에는 메인에서 회원정보를 받아올 때(로그인 직후 포함)와 로그아웃(resetMember/resetAuth) 때 따라간다.
const syncGtmUserInfo = () => sendUserInfo(store.state.login.accessToken ? store.state.member.loginIdHash : null)
syncGtmUserInfo()
store.subscribe(({ type }) => {
    if (["setLoginIdHash", "resetMember", "resetAuth"].includes(type)) syncGtmUserInfo()
})

// 문자 딥링크 진입(네이티브 브릿지 + 인증 가드). mount 전에 걸어야 최초 진입도 가드를 탄다.
// GTM 뒤에 둔다 — 이 가드가 곧바로 화면을 옮길 수 있어 그전에 클라이언트 정보가 올라가 있어야 한다.
setupDeepLink(router, store)

const app = createApp(App)
app.use(store).use(router).use(VueDaumPostcode)
app.mount('#app')
